/**
 * 法人情報・アカウント情報から請求先へフィールド値をコピーする（ボタン押下時のみ）。
 *
 * @param {ParentNode} root
 */
export function initBillingCopyFromRegistration(root = document) {
    root.querySelectorAll('[data-billing-copy-root]').forEach((copyRoot) => {
        const copyButton = copyRoot.querySelector('[data-billing-copy-trigger]');
        const form = copyRoot.closest('form');

        if (!copyButton || !form) {
            return;
        }

        let fieldMap = {};
        try {
            fieldMap = JSON.parse(copyRoot.dataset.billingCopyMap ?? '{}');
        } catch {
            return;
        }

        copyButton.addEventListener('click', () => {
            Object.entries(fieldMap).forEach(([sourceFieldName, targetFieldName]) => {
                const sourceInput = form.querySelector(`[name="${sourceFieldName}"]`);
                const targetInput = form.querySelector(`[name="${targetFieldName}"]`);

                if (!sourceInput || !targetInput) {
                    return;
                }

                targetInput.value = sourceInput.value;
            });
        });
    });
}
